import React from 'react';
import { useLabels } from 'wsm-common-data';
import { hideVehicleToolbar } from '../utils';

const ScrollToTop = () => {
	const labels = useLabels();
	const scrollLabel = labels.get('SCROLL_TO_TOP');

	const handleScroll = () => {
		setTimeout(() => {
			window.scrollTo({ top: -50, behavior: 'smooth' });
			hideVehicleToolbar();
		}, 10);
	};

	return (
		<p className="h6 text-content-container flex-shrink-0">
			{/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
			<a href="#" onClick={handleScroll}>
				{scrollLabel}
			</a>
		</p>
	);
};

export default ScrollToTop;
